import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { FaLinkedin, FaTwitter, FaGithub, FaUserTie, FaUserGraduate } from "react-icons/fa";

const Team = () => {
  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  const teamMembers = [
    {
      name: "Raunak Gupta",
      role: "Founder & Developer",
      bio: "Digital marketing strategist with experience in driving brand growth through innovative campaigns.",
      icon: <FaUserTie className="profile-icon" />,
      social: {
        linkedin: "https://www.linkedin.com/in/raunak-gupta-53a8b424b",
        twitter: "#",
        github: "https://github.com/raunak-2811",
      },
      accentColor: "#3B82F6", // blue
    },
    {
      name: "Vertika Sahu",
      role: "CEO & Creative Designer",
      bio: "Design expert focused on creating compelling brand identities and seamless user experiences.",
      icon: <FaUserGraduate className="profile-icon" />,
      social: {
        linkedin: "https://www.linkedin.com/in/vertika-sahu-58399a20a",
      },
      accentColor: "#EC4899", // pink
    },
  ];

  const container = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const item = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 100,
        damping: 10,
      },
    },
  };

  return (
    <section id="team" className="team" ref={ref}>
      <div className="container">
        <motion.h2
          className="section-title"
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          Meet Our <span className="text-gradient">Team</span>
        </motion.h2>
        <motion.p
          className="section-subtitle"
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          The talented professionals driving your digital success
        </motion.p>

        <motion.div
          className="team-grid"
          variants={container}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
        >
          {teamMembers.map((member, index) => (
            <motion.div
              key={index}
              className="team-card"
              variants={item}
              whileHover={{
                y: -10,
                boxShadow: `0 15px 30px -5px ${member.accentColor}40`,
              }}
              style={{ "--accent-color": member.accentColor }}
            >
              <div className="team-img-container">
                <div className="profile-icon-container">
                  {member.icon}
                </div>
                <div className="social-links">
                  <a href={member.social.linkedin} aria-label="LinkedIn" target="_blank" rel="noopener noreferrer">
                    <FaLinkedin />
                  </a>
                  {member.social.twitter && (
                    <a href={member.social.twitter} aria-label="Twitter" target="_blank" rel="noopener noreferrer">
                      <FaTwitter />
                    </a>
                  )}
                  {member.social.github && (
                    <a href={member.social.github} aria-label="GitHub" target="_blank" rel="noopener noreferrer">
                      <FaGithub />
                    </a>
                  )}
                </div>
              </div>
              <div className="team-info">
                <h3>{member.name}</h3>
                <p className="role">{member.role}</p>
                <p className="bio">{member.bio}</p>
                <div className="team-footer">
                  <span className="contact-btn">Contact</span>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Team;